import React, { useEffect, useState } from 'react';
import {
    EuiOverlayMask,
    EuiFlexGroup,
    EuiFlexItem,
    EuiTitle,
    EuiModal,
    EuiModalHeader,
    EuiModalBody,
    EuiButtonGroup,
    EuiLoadingContent,
} from '@elastic/eui';
import './style.css';
import { ETLDeliveryManagement } from '../orderDetailsCard/eltRiderManagemnet';
import { FabDeliveryManagment } from '../orderDetailsCard/fabDeliveryManagement';
import { DunzoRiderTab } from '../orderDetailsCard/dunzoRider';
import { WeFastRiderTab } from '../orderDetailsCard/weFastRider';
import { ScoutRiderTab } from '../orderDetailsCard/scoutRider';
import { AhoyRiderTab } from '../orderDetailsCard/ahoyRider';
import { ShadowFaxRiderTab } from '../orderDetailsCard/shadowFaxRider';
import { PorterRiderTab } from '../orderDetailsCard/porterRider';
import { useSelector } from 'react-redux';
import API from '../../api/axios/API';
import PidgeServices from '../orderDetailsCard/PidgeServices';
import { orderBy } from 'lodash';
import { FlashRider } from '../orderDetailsCard/FlashRider';
import { HLDedicated } from '../orderDetailsCard/HLDedicated';
import { AdlogsRiderTab } from '../orderDetailsCard/adlogsRider';
import { ADLOGS_SUB_SERVICES } from './adlogsServices';

const isAdlogsSubServiceActivated = (trps, key) =>
    !!(
        trps?.[`is_adlogs_${key}_integration_enabled`] &&
        trps?.[`adlogs_${key}_request`]?.status === 'approved'
    );

export const RiderManageModal = (props) => {
    const selectedRestaurantId = useSelector((state) => state.auth.selectedRestaurantId);
    const [tabState, setTabState] = useState('bolt-rider');

    const [deliveryServices, setDeliveryServices] = useState([]);

    const [isPidgeServiceSelected, setIsPidgeServiceSelected] = useState(false);

    const [isLoadingPidgeRider, setIsLoadingPidgeRider] = useState(false);

    // [{id: 'bolt', label: 'Bolt Riders'}, {id: 'elt-riders', label: 'ELT Riders'}, {id: 'dunzo-riders', label: 'Dunzo Riders'}, {id: 'we-fast-riders', label: 'Wefast Riders'}, {id: 'scout-riders', label: 'Scout Riders'}, {id: 'ahoy-riders', label: 'Ahoy Riders'}]
    const [availablePidgeServices, setAvailablePidgeServices] = useState([]);

    const closeModal = () => {
        props.closeRiderModal();
    };

    console.log('props', props)

    useEffect(() => {
        if (
            props.order.outlet &&
            props.order.outlet.settings &&
            !props.order.outlet.settings.enable_own_rider_service
        ) {
            if (props.order.outlet && props.order.outlet.third_party_rider_setting) {
                riderEnableCheck();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.order.outlet]);

    useEffect(async () => {
        if (props.order.outlet && props.order.outlet.settings) {
            let innerArray = [];
            if (props.order.outlet.settings.enable_own_rider_service) {
                innerArray.push({ id: 'bolt-rider', label: 'Bolt Riders' });
            }
            if (props.order.outlet.settings?.pidge_service_enabled) {
                const pidgeServices = await getQuotation();
                setDeliveryServices([
                    ...innerArray,
                    ...orderBy(
                        pidgeServices?.map((el) => ({
                            id: `${el.network_id}`,
                            label: el.network_name,
                            params: el,
                            isDisabled: !el.pickup_now,
                        })) || [],
                        ['pickup_now']
                    ),
                ]);
                return;
            }

            if (props.order.outlet?.third_party_rider_setting?.elt_integration_available) {
                innerArray.push({ id: 'elt-rider', label: 'ELT Riders' });
            }

            if (props.order.outlet?.third_party_rider_setting?.dunzo_integration_available) {
                innerArray.push({ id: 'dunzo-rider', label: 'Dunzo Riders' });
            }

            if (props.order.outlet?.third_party_rider_setting?.wefast_integration_available) {
                innerArray.push({ id: 'we-fast-rider', label: 'Wefast Riders' });
            }

            if (props.order.outlet?.third_party_rider_setting?.scout_runner_integration_available) {
                innerArray.push({ id: 'scout-rider', label: 'Scout Riders' });
            }

            if (props.order.outlet?.third_party_rider_setting?.ahoy_integration_available) {
                innerArray.push({ id: 'ahoy-rider', label: 'Ahoy Riders' });
            }

            if (props.order.outlet?.third_party_rider_setting?.is_porter_integration_enabled) {
                innerArray.push({ id: 'porter-rider', label: 'Porter rider' });
            }

            if (props.order.outlet?.third_party_rider_setting?.is_shadowfax_integration_enabled) {
                innerArray.push({ id: 'shadow-fax-rider', label: 'Shadow fax Riders' });
            }

            if (props.order.outlet?.third_party_rider_setting?.is_flash_integration_enabled) {
                innerArray.push({ id: 'Flash', label: 'Flash Riders' });
            }

            if (props.order.outlet?.third_party_rider_setting?.is_hl_storebased_integration_enabled) {
                innerArray.push({ id: 'HL-Dedicated', label: 'HL Dedicated' });
            }

            const trps = props.order.outlet?.third_party_rider_setting;
            ADLOGS_SUB_SERVICES.forEach((svc) => {
                if (isAdlogsSubServiceActivated(trps, svc.key)) {
                    innerArray.push({ id: svc.tabId, label: svc.label });
                }
            });

            setDeliveryServices(innerArray);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.order.outlet]);

    const getQuotation = async () => {
        try {
            setIsLoadingPidgeRider(true);
            const response = await API.post(`/restaurants/${selectedRestaurantId}/pigde/get-quotation`, {
                order_id: props.order.order_id,
            });

            if (response.success) {
                setIsLoadingPidgeRider(false);
                setAvailablePidgeServices([...response?.response?.service_details]);

                return response?.response?.service_details;
            }
        } catch (error) {
            return [];
        }
    };

    const riderEnableCheck = () => {
        switch (1) {
            case props.order.outlet.third_party_rider_setting.elt_integration_available:
                setTabState('elt-rider');
                return;
            case props.order.outlet.third_party_rider_setting.dunzo_integration_available:
                setTabState('dunzo-rider');
                return;
            case props.order.outlet.third_party_rider_setting.wefast_integration_available:
                setTabState('we-fast-rider');
                return;
            case props?.order?.outlet?.third_party_rider_setting?.is_flash_integration_enabled:
                setTabState('Flash');
                return;
            case props.order.outlet.third_party_rider_setting.is_hl_storebased_integration_enabled:
                setTabState('HL-Dedicated');
                return;
            case props.order.outlet.third_party_rider_setting.scout_runner_integration_available:
                setTabState('scout-rider');
                return;
            case props.order.outlet.third_party_rider_setting.ahoy_integration_available:
                setTabState('ahoy-rider');
                return;
            case parseInt(props.order.outlet.third_party_rider_setting.is_shadowfax_integration_enabled):
                setTabState('shadow-fax-rider');
                return;
            case parseInt(props.order.outlet.third_party_rider_setting.is_porter_integration_enabled):
                setTabState('porter-rider');
                return;
            default: {
                const trps = props.order.outlet.third_party_rider_setting;
                const activated = ADLOGS_SUB_SERVICES.find((svc) => isAdlogsSubServiceActivated(trps, svc.key));
                if (activated) {
                    setTabState(activated.tabId);
                }
                return;
            }
        }
    };

    const serviceCheck = () => {
        let msg = riderServiceCheckSwitch();

        return (
            <EuiFlexItem style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                <b>{msg}</b>
            </EuiFlexItem>
        );
    };

    const riderServiceCheckSwitch = () => {
        switch (1) {
            case props.order.outlet.settings.enable_own_rider_service:
            case props.order.outlet.third_party_rider_setting.elt_integration_available:
            case props.order.outlet.third_party_rider_setting.dunzo_integration_available:
            case props.order.outlet.third_party_rider_setting.wefast_integration_available:
            case props.order.outlet.third_party_rider_setting.is_flash_integration_enabled:
            case props.order.outlet.third_party_rider_setting.is_hl_storebased_integration_enabled:
            case props.order.outlet.third_party_rider_setting.scout_runner_integration_available:
            case props.order.outlet.third_party_rider_setting.ahoy_integration_available:
            case props.order.outlet.third_party_rider_setting.is_porter_integration_enabled:
            case parseInt(props.order.outlet.third_party_rider_setting.is_shadowfax_integration_enabled):
                return '';
            default: {
                const trps = props.order.outlet.third_party_rider_setting;
                const anyAdlogsSubActivated = ADLOGS_SUB_SERVICES.some((svc) =>
                    isAdlogsSubServiceActivated(trps, svc.key)
                );
                return anyAdlogsSubActivated ? '' : 'Please select atleast one Rider service';
            }
        }
    };

    const onChangeDeliveryService = (value) => {
        setTabState(value);

        const isPidgeService = availablePidgeServices?.some((el) => el?.network_id == value);

        setIsPidgeServiceSelected(isPidgeService);
    };
    return (
        <>
            {props.riderModalOpen && (
                <EuiOverlayMask>
                    <EuiModal
                        onClose={() => {
                            closeModal();
                        }}
                        style={{ zIndex: 6000, maxWidth: 300 }}
                    >
                        <EuiModalHeader>
                            <EuiTitle size='m'>
                                <h2>Rider Manage</h2>
                            </EuiTitle>
                        </EuiModalHeader>
                        {isLoadingPidgeRider ? (
                            <EuiLoadingContent
                                style={{ paddingLeft: 24, paddingRight: 24, marginBottom: 32 }}
                                lines={4}
                            />
                        ) : (
                            <EuiModalBody>
                                <EuiFlexGroup
                                    alignItems='center'
                                    justifyContent='spaceBetween'
                                    style={{
                                        overflowX: 'scroll',
                                    }}
                                >
                                    <EuiFlexItem>
                                        <EuiButtonGroup
                                            options={deliveryServices}
                                            idSelected={tabState}
                                            onChange={onChangeDeliveryService}
                                            color='primary'
                                        />
                                    </EuiFlexItem>
                                </EuiFlexGroup>

                                {tabState === 'elt-rider' &&
                                props.order.outlet &&
                                props.order.outlet.third_party_rider_setting &&
                                props.order.outlet.third_party_rider_setting.elt_integration_available ? (
                                    <ETLDeliveryManagement {...props} />
                                ) : (
                                    ''
                                )}
                                {tabState === 'bolt-rider' &&
                                props.order.outlet &&
                                props.order.outlet.settings &&
                                props.order.outlet.settings.enable_own_rider_service ? (
                                    <FabDeliveryManagment {...props} />
                                ) : (
                                    ''
                                )}
                                {tabState === 'dunzo-rider' &&
                                props.order.outlet &&
                                props.order.outlet.third_party_rider_setting &&
                                props.order.outlet.third_party_rider_setting.dunzo_integration_available ? (
                                    <DunzoRiderTab {...props} />
                                ) : (
                                    ''
                                )}
                                {tabState === 'we-fast-rider' &&
                                props.order.outlet &&
                                props.order.outlet.third_party_rider_setting &&
                                props.order.outlet.third_party_rider_setting.wefast_integration_available ? (
                                    <WeFastRiderTab {...props} />
                                ) : (
                                    ''
                                )}
                                {tabState === 'Flash' &&
                                props.order.outlet &&
                                props.order.outlet.third_party_rider_setting?.is_flash_integration_enabled ? (
                                    <FlashRider {...props} />
                                ) : (
                                    ''
                                )}
                                {tabState === 'HL-Dedicated' &&
                                props.order.outlet &&
                                props.order.outlet.third_party_rider_setting &&
                                props.order.outlet.third_party_rider_setting.is_hl_storebased_integration_enabled ? (
                                    <HLDedicated {...props} />
                                ) : (
                                    ''
                                )}
                                {tabState === 'scout-rider' &&
                                props.order.outlet &&
                                props.order.outlet.third_party_rider_setting &&
                                props.order.outlet.third_party_rider_setting.scout_runner_integration_available ? (
                                    <ScoutRiderTab {...props} />
                                ) : (
                                    ''
                                )}
                                {tabState === 'ahoy-rider' &&
                                props.order.outlet &&
                                props.order.outlet.third_party_rider_setting &&
                                props.order.outlet.third_party_rider_setting.ahoy_integration_available ? (
                                    <AhoyRiderTab {...props} />
                                ) : (
                                    ''
                                )}
                                {tabState === 'shadow-fax-rider' &&
                                parseInt(
                                    props?.order?.outlet?.third_party_rider_setting?.is_shadowfax_integration_enabled
                                ) ? (
                                    <ShadowFaxRiderTab {...props} />
                                ) : (
                                    ''
                                )}

                                {isPidgeServiceSelected && (
                                    <PidgeServices
                                        closeModal={closeModal}
                                        orderId={props.order.order_id}
                                        tabState={tabState}
                                        availablePidgeServices={availablePidgeServices}
                                        isOrderAccepted={props?.order?.status?.restaurant_accepted_at}
                                        {...props}
                                    />
                                )}

                                {tabState === 'porter-rider' &&
                                parseInt(
                                    props?.order?.outlet?.third_party_rider_setting?.is_porter_integration_enabled
                                ) ? (
                                    <PorterRiderTab {...props} />
                                ) : (
                                    ''
                                )}
                                {ADLOGS_SUB_SERVICES.map((svc) => {
                                    if (tabState !== svc.tabId) return null;
                                    if (!isAdlogsSubServiceActivated(props?.order?.outlet?.third_party_rider_setting, svc.key))
                                        return null;
                                    return (
                                        <AdlogsRiderTab
                                            key={svc.tabId}
                                            service={`${svc.key}_al`}
                                            label={svc.label.replace(' Riders', '')}
                                            {...props}
                                        />
                                    );
                                })}
                                {serviceCheck()}
                            </EuiModalBody>
                        )}
                        {/* <EuiModalFooter>
                            <EuiButton onClick={() => closeModal()} fill>
                                Close
                            </EuiButton>
                        </EuiModalFooter> */}
                    </EuiModal>
                </EuiOverlayMask>
            )}
        </>
    );
};
